import { TopupsModel, TopupStatusTitles } from '@/entities/topups'
import { formatCurrency } from '@/shared/lib/currency'
import { formatDate } from '@/shared/lib/date'
import { formatRequisite } from '@/shared/lib/requisite/formatRequisite'
import { getShortenId } from '@/shared/utils/getShortenId'
import { ColumnDef } from '@tanstack/react-table'
import { Link } from 'react-router-dom'
import { CopyBlock } from '@/shared/components/CopyBlock/CopyBlock'

export const traderTopupsColumns: ColumnDef<TopupsModel>[] = [
  {
    accessorKey: 'id',
    header: () => <div>ID заявки</div>,
    cell: ({ row }) => {
      const id = row.getValue<string>('id')
      return (
        <div className="flex flex-col">
          <CopyBlock text={id} title={id}>
            <Link to={`/deals/${id}`} className="text-primary">
              {getShortenId(id)}
            </Link>
          </CopyBlock>
        </div>
      )
    },
  },
  {
    accessorKey: 'date',
    header: 'Дата и время',
    cell: ({ row }) => {
      return (
        <span className="font-medium text-sm whitespace-nowrap">
          {formatDate(row.original.createdAt, 'dateShortAndTimeWithoutSec')}
        </span>
      )
    },
  },
  {
    accessorKey: 'amount',
    header: 'Сумма',
    cell: ({ row }) => {
      return (
        <div className="flex flex-col whitespace-nowrap">
          <CopyBlock text={row.original.amountTo.toFixed(2)}>
            {formatCurrency(row.original.amountTo, row.original.currencyTo)}
          </CopyBlock>

          <CopyBlock text={row.original.amountFrom.toFixed(2)} color="secondary">
            {formatCurrency(row.original.amountFrom, row.original.currencyFrom)}
          </CopyBlock>
        </div>
      )
    },
  },
  {
    accessorKey: 'requisite',
    header: 'Реквизит',
    cell: ({ row }) => {
      return (
        <div className="flex flex-col">
          <CopyBlock text={row.original.paymentRequisitToValue}>
            {formatRequisite(row.original.paymentRequisitToValue ?? '')}
          </CopyBlock>
        </div>
      )
    },
  },
  {
    accessorKey: 'status',
    header: 'Статус',
    cell: ({ row }) => {
      const status = row.original.status
      const title = TopupStatusTitles[status]
      return <span className="font-medium text-sm">{title}</span>
    },
  },
]
